import { connect } from 'react-redux';

// import { getOfficesShortList } from '../Offices/officesActions';
// // Actions
// import { addTaskLocation, getTaskLocation } from '../Tasks/tasksActions';
// // Component
import CheckHands from './CheckHands';

// Actions
import { getCheckHandsData } from './checkHandsActions';

// Store props to map with current state
const mapStateToProps = state => ({
  // loading
  checkHandsLoading: state.checkHands.checkHandsLoading,
  // data
  checkHandsData: state.checkHands.checkHandsData,
  // error
  checkHandsError: state.checkHands.checkHandsError,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getCheckHandsData: params => dispatch(getCheckHandsData(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(CheckHands);
